"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setup = exports.getTelemetry = exports.init = void 0;
var browser_1 = require("@cian/config/browser");
var shared_1 = require("../shared");
var internal_1 = require("../shared/internal");
var internal_2 = require("./internal");
var telemetry;
var telemetrySettings;
var identity = function (val) { return val; };
function setup(settings) {
    if (settings === void 0) { settings = {}; }
    var _a = settings.keyTransformer, keyTransformer = _a === void 0 ? identity : _a;
    telemetrySettings = {
        keyTransformer: keyTransformer,
    };
}
exports.setup = setup;
var DEFAULT_STATSD_URL = 'http://master.browser-telemetry.dev3.cian.ru/public/v1/send-stats/';
var DEFAULT_STATSD_UPDATE_PERIOD = 5000;
/**
 * Публичная функция инициализации телеметрии
 * @returns {ITelemetryLogger}
 */
function init() {
    if (telemetry) {
        return telemetry;
    }
    if (!telemetrySettings) {
        throw new shared_1.TelemetryError({
            message: 'Settings was not set for teletemetry. Forgot to call setup() before config initialization?',
            domain: 'browser#init()',
        });
    }
    var config = (0, browser_1.init)();
    var projectName = config.getStrict('projectName');
    var prefix = "browser.microservice.".concat(projectName);
    var keyTransformer = function (key) { return telemetrySettings.keyTransformer((0, internal_1.generateTelemetryKey)(prefix)(key)); };
    var transport = getTelemetryTransport();
    telemetry = new internal_1.TelemetryLogger({
        transport: transport,
        keyTransformer: keyTransformer,
    });
    return telemetry;
}
exports.init = init;
function getTelemetryTransport() {
    var config = (0, browser_1.getConfig)();
    var type = config.get('telemetry.browser.type') || shared_1.ETelemetryLoggerType.STDOUT;
    if (type === shared_1.ETelemetryLoggerType.STDOUT) {
        return new internal_1.ConsoleTransport();
    }
    var url = config.get('telemetry.browser.url') || DEFAULT_STATSD_URL;
    var period = config.get('telemetry.browser.period') || DEFAULT_STATSD_UPDATE_PERIOD;
    return new internal_2.AjaxTransport({ url: url, period: period });
}
/**
 * Публичная функция получения синглтона телеметрии
 * @returns {ITelemetryLogger}
 */
var getTelemetry = function () {
    if (!telemetry) {
        throw new Error('telemetry not initialized yet, call init function first');
    }
    return telemetry;
};
exports.getTelemetry = getTelemetry;
//# sourceMappingURL=interface.js.map